import { useMutation } from 'react-query';
import axios from 'utilities/axios';

const API = {
  SAVE_POLITICAL_DECLARATION: 'customers/save-political-declaration',
};

export const useSavePoliticalDeclaration = () => {
  return useMutation(
    (data) => axios.post(API.SAVE_POLITICAL_DECLARATION, data),
    {
      onSuccess: () => {},
    }
  );
};


